import { useContext } from "react";

import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { EditActionContext } from "./EditActionContext";

function useUpdate(modelConfig: any) {
  const { element, setBackendFormErrors } = useContext(EditActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    // Sanear campos antes de enviar
    const payload = { ...element };
    if (payload.status !== 2) {
      payload.cancellation_reason = null;
      payload.cancelled_at = null;
    } else {
      if (payload.cancelled_at) {
        try {
          payload.cancelled_at = new Date(payload.cancelled_at).toISOString();
        } catch (e) {}
      }
    }
    update(modelConfig.endpoint, element.id, payload)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
